import create from './create'
import export_ from './export'

export default {
  loading: 'Загрузка чатов...',
  empty: 'Нет чатов',

  type: {
    image: 'Изображение',
    document: 'Документ',
    video: 'Видео',
  },

  select_assigned: {
    title: '',
    all: 'Все чаты',
    assigned_me: 'Назначенные на меня',
    favorite: 'Избранное',
    resolved: 'Решённые',
  },
  select_status: {
    title: 'Статус',
    all: 'Все',
    0: 'Новый',
    1: 'Чат',
    2: 'Решено',
  },

  create,
  export: export_,
}
